import { BpkBox } from '@skyscanner-internal/backpack-web/bpk-component-layout';

import Rating from '../Rating/Rating';

import type { RatingInfo } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ProviderRating';

type DetailRatingProps = {
  ratingInfo: RatingInfo;
};

export default (props: DetailRatingProps) => {
  const { ratingInfo } = props;

  if (!ratingInfo) {
    return null;
  }

  return (
    <BpkBox width="100%" data-testid="detail-rating">
      {ratingInfo.items.map((item) => (
        <Rating
          key={item.name}
          rating={item.rating}
          label={item.name}
          ariaLabel={item.ariaLabel || ''}
        />
      ))}
    </BpkBox>
  );
};
